var getClassName = function getClassName(name, type) {
  return ['dcar', name, type].filter(Boolean).join('-');
};

export { getClassName };